import { useEffect, type FC } from 'react';

import { useLoginState } from '@xing-com/crate-hooks-use-login-state';

import { useTrackPage } from '../../hooks/use-track-page';
import {
  pagesTrackingName,
  useNwtTrackingCompanies,
} from '../../utils/tracking';

import { LIMostVisitedCompanies } from './li-most-visited-companies';
import { LOMostVisitedCompanies } from './lo-most-visited-companies';

export const MostVisitedCompanies: FC = () => {
  const { isLoggedIn } = useLoginState();
  const trackNwtEvent = useNwtTrackingCompanies();

  useEffect(() => {
    trackNwtEvent({
      eventSchema: 'basic',
      page: 'companies/most_visited',
      event: 'viewed_screen',
    });
  }, []);

  useTrackPage({ pageName: pagesTrackingName.mostVisited });

  const MostVisitedCompaniesPage = isLoggedIn
    ? LIMostVisitedCompanies
    : LOMostVisitedCompanies;

  return <MostVisitedCompaniesPage />;
};
